export const login = () => ({
    type: 'LOGIN'
  });
  
  export const logout = () => ({
    type: 'LOGOUT'
  });
  